<template>
	<div class="tpl trend-notice-wrap">
		<mt-header title="消息通知" fixed>
			<router-link :to="{name:'trends',query:{'selected':selected}}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div class="notice-list">
			<ul>
				<router-link tag="li" :to="{name:'comment-list',query:{selected:selected}}">
					<div class="item-left">
						<div class="list-img">
							<img src="../../assets/img/trends/dyn_message_ic_com.png"/>
							<mt-badge class="nums" size="small" color="#F74E2F">{{numsInfo.comment}}</mt-badge>
						</div>
						评论
					</div>
					<span class="icon-enter">
						<img src="../../assets/img/trends/dyn_message_ic_adv.png"/>
					</span>
				</router-link>
				<router-link tag="li" :to="{name:'good-list',query:{selected:selected}}">
					<div class="item-left">
						<div class="list-img">
							<img src="../../assets/img/trends/dyn_message_ic_like.png"/>
							<mt-badge class="nums" size="small" color="#F74E2F">{{numsInfo.likes}}</mt-badge>
						</div>
						点赞
					</div>
					<span class="icon-enter">
						<img src="../../assets/img/trends/dyn_message_ic_adv.png"/>
					</span>
				</router-link>
				<router-link tag="li" :to="{name:'reward-list',query:{selected:selected}}">
					<div class="item-left">
						<div class="list-img">
							<img src="../../assets/img/trends/dyn_message_ic_reward.png"/>
							<mt-badge class="nums" size="small" color="#F74E2F">{{numsInfo.gift}}</mt-badge>
						</div>
						打赏
					</div>
					<span class="icon-enter">
						<img src="../../assets/img/trends/dyn_message_ic_adv.png"/>
					</span>
				</router-link>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		name:"trend-notice",
		data(){
			return{
				uid:"",
				selected:"",
				numsInfo:"",
			}
		},
		created(){
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "trends");
			this.$store.commit("changeTabBarShow", false);

			this.selected = this.$route.query.selected;
			
			console.log(this.selected)
			
			this.getInfo();
		},
		methods:{
			getInfo(){
				if(!this.isLogin()){return false;}
				this.$axios({
					url:"Dynamic/getUnreadMessageSum",
					method:"post",
					data:{
						uid:this.uid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.numsInfo = res.data.data;
					}else{
						this.$toast({
							message: "操作失败！",
							position: "bottom",
							duration: 3000
						});
					}
				}).catch(err=>{
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped>
	.trend-notice-wrap{
		padding-top: 2.5rem;
		background: #fff;
	}
	.notice-list li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1rem;
		border-bottom: 1px solid #f3f3f3;
	}
	.notice-list li:active{
		background: #fafafa;
	}
	.notice-list li .item-left{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 1rem;
		color: #282828;
	}
	.notice-list li .list-img{
		position: relative;
		margin-right: 1.2rem;
	}
	.notice-list li .list-img img{
		width: 2rem;
	}
	.notice-list li .list-img .nums{
		position: absolute;
		top: -0.3rem;
		left: 80%;
	}
	.mint-badge.is-size-small{
		padding: 0 5px;
	}
	.notice-list li .icon-enter img{
		width: 1.2rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Trends/TrendNotice.vue